import BaseService from "@/services/BaseService.ts";
import {supabase} from "@supabaseClient";
import logger from "@logger";
import {ETFHolding} from "@/integrations/supabase/etf.models.ts";

class ETFHoldingService extends BaseService {

    async createEtfHolding(request: ETFHoldingCreateRequest): Promise<ETFHolding> {
        const payload = this.convertRequestToSnakeCase(request);
        const { data, error } = await supabase
            .from('etf_holdings')
            .insert(payload)
            .select()
            .single();

        if (error) {
            await this.handleError(error);
            throw error;
        }

        return data
    }

    async fetchEtfHoldings(userId: string) {
        logger.info(`Fetching ETF holdings for user ${userId}`);

        const { data, error } = await supabase
            .from('etf_holdings')
            .select('*')
            .eq('user_id', userId)
            .order('created_at', { ascending: false });

        if (error) {
            await this.handleError(error);
            throw error;
        }

        return data;
    }

    async updateEtfHolding(request: ETFHoldingUpdateRequest): Promise<ETFHolding> {
        const payload = this.convertRequestToSnakeCase(request);
        const { data, error } = await supabase
            .from('etf_holdings')
            .update(payload)
            .eq('id', payload.id)
            .eq("user_id", payload.user_id)
            .select()
            .single();

        if (error) {
            await this.handleError(error);
            throw error;
        }

        return data
    }

    async deleteEtfHolding(request: ETFHoldingDeleteRequest): Promise<void> {
        const { error } = await supabase
            .from('etf_holdings')
            .delete()
            .eq('id', request.id)
            .eq("user_id", request.userId);

        if (error) {
            await this.handleError(error);
            throw error;
        }
    }

}

export default new ETFHoldingService();
